import React from "react";

// Imports
import TitleText from "./TitleText";

const howItWorksData = [
  {
    number: "1",
    title: "Explore",
    desc1: "Browse our wide range of",
    desc2: "tests tailored to your health",
    desc3: "needs",
  },
  {
    number: "2",
    title: "Book",
    desc1: "Choose the test and book ",
    desc2: "online in just a few clicks",
    desc3: "",
  },
  {
    number: "3",
    title: "Sample Collection",
    desc1: "Get your sample collected",
    desc2: "at home or visit the nearest",
    desc3: "lab partner",
  },
  {
    number: "4",
    title: "Reports Delivered",
    desc1: "Receive your accurate test",
    desc2: "reports promptly via our",
    desc3: "website",
  },
];

const HowItWorks = () => {
  return (
    <>
      {/* Large Screens */}
      <div className="w-full h-fit hidden lg:flex lg:flex-col justify-start items-center space-y-[3%]">
        <TitleText text="How It Works?" />
        <div className="w-full h-fit flex justify-between items-start">
          {howItWorksData?.map((item, index) => (
            <div
              className="flex flex-col justify-start items-start"
              key={index}
            >
              <span className="font-medium text-[1.25vw] text-primaryColor">
                {item.number}
              </span>
              <p className="font-semibold text-[1vw] text-textPrimaryColor mt-[2%] mb-[1%]">
                {item?.title}
              </p>
              <p className="font-normal text-[0.9vw] text-textSecondaryColor">
                {item?.desc1}
              </p>
              <p className="font-normal text-[0.9vw] text-textSecondaryColor">
                {item?.desc2}
              </p>
              <p className="font-normal text-[0.9vw] text-textSecondaryColor">
                {item?.desc3}
              </p>
            </div>
          ))}
        </div>
        <div className="w-full h-fit flex flex-col justify-between items-center">
          <p className="font-normal text-[0.9vw] text-textSecondaryColor">
            At Fine Labs, your health is our priority. Whether you’re looking
            for routine checkups or specialized
          </p>
          <p className="font-normal text-[0.9vw] text-textSecondaryColor">
            diagnostics, we’re here to make the process effortless and reliable.
          </p>
          <p className="font-normal text-[0.9vw] text-textSecondaryColor my-[2%]">
            Start your health journey with us today!
          </p>
          <p className="font-medium text-[1vw] text-primaryColor mb-[3%]">
            Fine Labs – Trusted Tests, Better Health
          </p>
        </div>
      </div>

      {/* Small Screens */}
      <div className="w-full h-fit flex flex-col justify-start items-center space-y-[5%] lg:hidden">
        <TitleText text="How It Works?" />
        <div className="w-full h-fit flex flex-col justify-start items-start space-y-[3%]">
          {howItWorksData?.map((item, index) => (
            <div
              className="flex flex-col justify-start items-start"
              key={index}
            >
              <span className="font-semibold text-[5vw] text-primaryColor">
                {item.number}
              </span>
              <p className="font-semibold text-[4vw] text-textPrimaryColor mt-[1%] mb-[1%]">
                {item?.title}
              </p>
              <p className="font-normal text-[3.5vw] text-textSecondaryColor">
                {item?.desc1} {item?.desc2} {item?.desc3}
              </p>
            </div>
          ))}
        </div>
        <div className="w-full h-fit flex flex-col justify-between items-center">
          <p className="font-normal text-[3.5vw] text-textSecondaryColor text-center">
            At Fine Labs, your health is our priority. Whether you’re looking
            for routine checkups or specialized diagnostics, we’re here to make
            the process effortless and reliable.
          </p>
          <p className="font-normal text-[3.5vw] text-textSecondaryColor my-[3%] text-center">
            Start your health journey with us today!
          </p>
          <p className="font-medium text-[4vw] text-primaryColor mb-[3%] text-center">
            Fine Labs – Trusted Tests, Better Health
          </p>
        </div>
      </div>
    </>
  );
};

export default HowItWorks;
